import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import * as Cookies from 'js-cookie';

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== 'production';
export default new Vuex.Store({
  state: {
    token: {
      token_type: null,
      expires_in: null,
      access_token: null,
      refresh_token: null,
    },
  },
  mutations: {
    setAccessToken(state, token) {
      state.token = token;
    },
    setOnlyAccessToken(state, token) {
      state.token.access_token = token;
    },
    setLogout(state, payload) {
      state.token = {};
    },
  },
  getters: {
    getToken(state, getter) {
      return state.token;
    },
    getAccessToken(state, getter) {
      return state.token.access_token;
    },
  },
  getAccessToken(state, getter) {
    return state.token.access_token;
  },
  actions: {},
  plugins: [
    createPersistedState({
      storage: {
        key: 'token',
        getItem: (key) => Cookies.get(key),
        // Please see https://github.com/js-cookie/js-cookie#json, on how to handle JSON.
        setItem: (key, value) => Cookies.set(key, value, { expires: 3, secure: false }),
        removeItem: (key) => Cookies.remove(key),
      },
    }),
  ],
  strict: debug,
});
